import React from 'react';
import { BarChart3, Clock, Shield, Cpu } from 'lucide-react'; 

const WhyChooseUs: React.FC = () => (
  <section className="w-full py-12 md:py-24 lg:py-32">
    <div className="container px-4 md:px-6">
      <div className="grid gap-10 lg:grid-cols-2">
        <div className="space-y-4">
          <h2 className="text-3xl font-bold tracking-tighter md:text-4xl/tight">
            Why Choose FF Automaton?
          </h2>
          <p className="text-muted-foreground md:text-xl">
            Our cutting-edge technology and proven track record make us the trusted choice for algorithmic trading solutions.
          </p>
        </div>
        <div className="grid gap-6 lg:grid-cols-2">
          {/* Superior Performance */}
          <div className="flex items-start gap-4">
            <BarChart3 className="h-6 w-6 text-primary" />
            <div>
              <h3 className="text-lg font-semibold">Superior Performance</h3>
              <p className="text-muted-foreground">Delivering top-tier trading results consistently.</p>
            </div>
          </div>

          {/* 24/7 Operation */}
          <div className="flex items-start gap-4">
            <Clock className="h-6 w-6 text-primary" />
            <div>
              <h3 className="text-lg font-semibold">24/7 Operation</h3>
              <p className="text-muted-foreground">Our systems run round the clock to seize every opportunity.</p>
            </div>
          </div>

          {/* Risk Management */}
          <div className="flex items-start gap-4">
            <Shield className="h-6 w-6 text-primary" />
            <div>
              <h3 className="text-lg font-semibold">Risk Management</h3>
              <p className="text-muted-foreground">Implementing robust strategies to mitigate potential risks.</p>
            </div>
          </div>

          {/* Advanced Technology */}
          <div className="flex items-start gap-4">
            <Cpu className="h-6 w-6 text-primary" />
            <div>
              <h3 className="text-lg font-semibold">Advanced Technology</h3>
              <p className="text-muted-foreground">Utilizing the latest tech to stay ahead in the market.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;